import { useEffect, useState } from 'react';


function readDeviceLayout() {
  const viewport = window.visualViewport;
  const width = Math.round(viewport?.width || window.innerWidth);
  const height = Math.round(viewport?.height || window.innerHeight);
  const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const type = width < 640 ? 'phone' : width < 1024 || (coarsePointer && width < 1180) ? 'tablet' : 'desktop';

  return {
    type,
    width,
    height,
    orientation: width > height ? 'landscape' : 'portrait',
    input: coarsePointer ? 'touch' : 'pointer',
  };
}

export default function useDeviceLayout() {
  const [layout, setLayout] = useState(() => readDeviceLayout());

  useEffect(() => {
    let frame;
    const update = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => setLayout(readDeviceLayout()));
    };
    const viewport = window.visualViewport;

    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    viewport?.addEventListener('resize', update);
    viewport?.addEventListener('scroll', update);
    update();

    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
      viewport?.removeEventListener('resize', update);
      viewport?.removeEventListener('scroll', update);
    };
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.dataset.device = layout.type;
    root.dataset.orientation = layout.orientation;
    root.dataset.input = layout.input;
    root.style.setProperty('--app-viewport-width', `${layout.width}px`);
    root.style.setProperty('--app-viewport-height', `${layout.height}px`);
  }, [layout]);

  return layout;
}
